import React from 'react';
import { createGlobalStyle } from 'styled-components';
import Layout from 'gatsby-theme-core/src/layout/layout';
import Header from 'gatsby-theme-header/src/components/header/index';
import Footer from 'gatsby-theme-footer/src/components/footer/index';
import Wrapper from '../../components/core-wrapper';
import Alert from '../../components/alert';

const ACMLayout = ({
  children,
  Main = 'main',
  prepend = null,
  append = null,
  ...props
}) => (
  <Layout {...props}>
    <GlobalStyle />
    {prepend}
    <Wrapper>
      <Header />
      <Alert />
      <Main>{children}</Main>
      <Footer />
    </Wrapper>
    {append}
  </Layout>
);

const GlobalStyle = createGlobalStyle`
  h1, h2, h3, h4, h5 {
    margin: 0;
  }
  address {
    font-style: normal;
  }
  pre {
    font-family: inherit;
  }
`;

export default ACMLayout;
